import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { IMAGES, SITE } from "../data/content";
import { useLang } from "../i18n";

export const Footer = () => {
  const { t, c } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-forest text-cream/90 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-tree/25 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-tangerine/15 blur-3xl" />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 relative">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img src={IMAGES.logo} alt="The Learning Tree Academy" className="w-12 h-12 rounded-full object-cover ring-2 ring-amber/60" />
              <span className="font-display font-extrabold text-lg leading-tight">
                The Learning Tree Academy
                <span className="block text-[11px] tracking-[0.22em] uppercase text-amber font-body font-semibold">Palm Bay, Florida</span>
              </span>
            </div>
            <p className="text-cream/70 text-sm leading-relaxed max-w-sm">{t("footer_tagline")}</p>
            <div className="flex items-center gap-4 mt-6">
              <a href={`mailto:${SITE.email}`} data-testid="footer-email-link"
                 className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-amber hover:text-charcoal transition-all duration-300">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4 text-cream">{t("footer_programs")}</h4>
            <ul className="space-y-2.5 text-sm text-cream/70">
              {c.programs.map((p) => (
                <li key={p.id}><Link className="hover:text-amber transition-colors" to="/programs">{p.title}</Link></li>
              ))}
              <li><Link className="hover:text-amber transition-colors" to="/blog">{t("footer_blog")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4 text-cream">{t("footer_touch")}</h4>
            <ul className="space-y-3 text-sm text-cream/70">
              <li className="flex gap-2.5">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-amber" />
                <span data-testid="footer-address">{SITE.address}</span>
              </li>
              <li className="flex gap-2.5">
                <Phone className="w-4 h-4 mt-0.5 shrink-0 text-amber" />
                <a href={SITE.phoneHref} className="hover:text-amber transition-colors">{SITE.phoneDisplay}</a>
              </li>
              <li className="flex gap-2.5">
                <Mail className="w-4 h-4 mt-0.5 shrink-0 text-amber" />
                <a href={`mailto:${SITE.email}`} className="hover:text-amber transition-colors break-all">{SITE.email}</a>
              </li>
            </ul>
            <img src={IMAGES.necpa} alt="NECPA Accredited" className="mt-6 h-12 w-auto bg-white rounded-lg px-3 py-1.5" />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-cream/50">
          <span>© {new Date().getFullYear()} {t("footer_rights")}</span>
          <span>{t("footer_licensed")}</span>
        </div>
      </div>
    </footer>
  );
};
